export default function SiteGreeter({ global}) {
    return (
        <div className="bg-cream text-xs">
            <div className="mx-auto flex w-full max-w-6xl items-center justify-evenly p-2 px-4 lg:px-8">
                {/* <h1 className="text-2xl font-bold mb-2">Welcome to Browned & Toasted</h1>
                <p className="text-lg text-gray-700">Explore our latest offerings and enjoy your stay!</p> */}

                <span><strong>Crafted in Seattle Since 2021 | </strong>Over 100,000 Treats Sold</span>
                <span className="hidden md:inline"><strong>Made with Goldmallow | </strong>Thousands of Samples Shared</span>
                {/* <span className="hidden sm:inline"><strong>Guaranteed Happiness | </strong>Trusted (5 stars)</span> */}
                <span className="inline"><img src="https://res.cloudinary.com/helpfulcrowd/image/upload/image/stores/8XS9k1/badges/1MCOzm/icon.png" width="272" alt="Helpful Crowd badge"></img></span>
            </div>
        </div>
    )
}
